import { BoxTitles } from "@boxes/BoxTitles";
import { BaseCurrencyInput, Button, Drawer, Select } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/filtered-audience.module.scss";

export const LastConversionConditionalForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [inLast, setInLast] = useState(node.data.inLast || null);
  const [inLastPeriod, setInLastPeriod] = useState(
    node.data.inLastPeriod || "DAY"
  );

  const getFreshNode = () => {
    const dataValue = { ...(node?.data || {}), inLast, inLastPeriod };
    return {
      ...node,
      data: dataValue,
    };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [inLast, inLastPeriod]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.LastConversionFilter}
    >
      <p className={styles.label}>Determine o tempo</p>

      <>
        <div className={styles.customPeriod}>
          <p>Nos últimos</p>

          <div className="d-flex mb-20">
            <BaseCurrencyInput
              placeholder="Inserir valor"
              className="w-50"
              precision={0}
              prefix=""
              type="tel"
              value={inLast}
              onChange={(v) => setInLast(v)}
            />
            <Select
              title="Selecione o tempo..."
              className="w-50 ml-15"
              value={inLastPeriod}
              options={[
                { label: "Dias", value: "DAY" },
                { label: "Meses", value: "MONTH" },
                { label: "Anos", value: "YEAR" },
              ]}
              onChange={(e) => setInLastPeriod(e.target.value)}
            />
          </div>
        </div>
      </>

      <div className={styles.footer}>
        <Button
          design="primary"
          className="w-100"
          onClick={() => onSave(getFreshNode())}
        >
          Salvar
        </Button>
      </div>
    </Drawer>
  );
};

const getInputType = (node) => {
  const { data } = node || {};
  if (data?.exact !== null && data?.exact !== undefined) {
    return "exact";
  } else if (data?.max !== null && data?.max !== undefined) {
    return "range";
  } else if (data?.min !== null && data?.min !== undefined) {
    return "minimum";
  } else {
    return "range";
  }
};
